import React, { useState } from 'react'
import Chevron from 'assets/svg/chevron.svg'

import s from './AccordionContainer.module.scss'
import { motion } from 'framer-motion'

interface PowerPackageCardProps {
  children: React.ReactNode
  title?: string
}

const AccordionContainer = (props: PowerPackageCardProps) => {
  const { title, children } = props
  const [toggle, setToggle] = useState(false)

  return (
    <motion.div
      className={s.accordionContainer}
      animate={{ backgroundColor: toggle ? '#FDFDFD' : '#F3F1F4' }}
      transition={{ duration: 0.2 }}
    >
      <button
        onClick={() => setToggle(!toggle)}
        className={s.accordionContainer__button}
      >
        <h3 className={s.accordionContainer__title}>
          {title ?? 'Velja orkuleið'}
        </h3>

        <motion.div
          className={s.accordionContainer__svg}
          animate={{ rotate: toggle ? 180 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <Chevron />
        </motion.div>
      </button>
      <div
        style={{
          opacity: toggle ? 1 : 0,
          height: toggle ? 'auto' : 0,
          pointerEvents: toggle ? 'auto' : 'none',
        }}
      >
        {children}
      </div>
    </motion.div>
  )
}
export default AccordionContainer
